var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionTutorial } from "./actionTutorial";
var initial = {
    tutorialStep: undefined,
};
export var reducerTutorial = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionTutorial.Init:
        case TypeActionTutorial.Select:
            return __assign({}, state, { tutorialStep: action.tutorialStep });
        case TypeActionTutorial.Complete:
            return {};
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/reducerTutorial.ts
// module id = 2984
// module chunks = 3